import React, { useState } from 'react';
import axios from 'axios';
import { API_URL, isApiConfigured } from '../../config';
import PasswordInput from './PasswordInput';
import './AuthForm.css';

const ResetPassword = ({ onRouteChange }) => {
  const params = new URLSearchParams(window.location.search);
  const email = params.get('email') || '';
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleReset = async () => {
    if (!email || !token) {
      setError('Reset link is missing required data.');
      return;
    }

    if (password.trim().length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (password.trim() !== confirmPassword.trim()) {
      setError('Passwords do not match. Re-enter the same password to confirm.');
      return;
    }

    if (!isApiConfigured) {
      setError('App configuration is missing the backend API URL.');
      return;
    }

    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${API_URL}/reset-password`, { email, token, password: password.trim() });
      setMessage(response.data.message || 'Password reset successful.');
    } catch (err) {
      setError(err.response?.data || 'Unable to reset password.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <article className="surface-card auth-card auth-card-reset">
      <main className="auth-main">
        <p className="auth-kicker">Ocula secure link</p>
        <h1 className="auth-title">Choose a new password</h1>

        <div className="auth-form-stack auth-reset-stack">
          <PasswordInput
            id="reset-password"
            label="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
            autoComplete="new-password"
          />

          <PasswordInput
            id="reset-confirm-password"
            label="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={isLoading}
            autoComplete="new-password"
          />

          {(error || message) && (
            <p className={error ? 'form-message form-message-error auth-form-notice' : 'form-message form-message-status auth-form-notice'} role={error ? 'alert' : 'status'}>
              {error || message}
            </p>
          )}

          <button className="button-primary auth-primary-button" onClick={handleReset} disabled={isLoading}>
            {isLoading ? 'Resetting...' : 'Reset password'}
          </button>

          <button className="auth-link-button" onClick={() => onRouteChange('signin')} type="button">
            Back to sign in
          </button>
        </div>
      </main>
    </article>
  );
};

export default ResetPassword;
